export class CustomSelectConstants {
    public static get CUSTOM_SELECT_SELECTOR(): string {
        return '.select-selected';
    }
    public static get CUSTOM_SELECT_DROPDOWN_SELECTOR(): string {
        return '.select-items';
    }
}
